import type { ExternalServiceConfig as ExternalService } from "api/schemas";

import { useGtmExternalService } from "../GoogleAnalytics/useGtm";

type GtmProps = {
  services: ExternalService[];
  propertySlug?: string;
};

const Gtm = ({ services, propertySlug }: GtmProps) => {
  useGtmExternalService({ externalServices: services, propertySlug });
  return null;
};

export default Gtm;
